import { useState } from 'react'
import { DisputStatus } from '@/features/orders/model/types'
import { useUpdateDisputStatus } from './useUpdateDisputStatus'

export const useDisputModals = (refetchDisputs?: () => void, hasError?: boolean) => {
  const [activeTopupId, setActiveTopupId] = useState<string>('') // для инвалидации заявки
  const [isDisputActionOpen, setIsDisputActionOpen] = useState(false) // окно действий по спору
  const [isConfirmAmountOpen, setIsConfirmAmountOpen] = useState(false) // подтвержение отправленной суммы
  const [isAcceptResultOpen, setIsAcceptResultOpen] = useState(false) // окно подтверждения, что спор принят
  const [isRejectConfirmOpen, setIsRejectConfirmOpen] = useState(false) // подтверждение отклонения
  const [isRejectResultOpen, setIsRejectResultOpen] = useState(false) // окно подтверждения, что спор отклонен
  const [confirmedAmount, setConfirmedAmount] = useState(0) // сумма, введенная клиентом
  const [activeDisputId, setActiveDisputId] = useState<string>('')
  const [isCreateDisputOpen, setIsCreateDisputOpen] = useState(false)

  const { handleUpdateStatus } = useUpdateDisputStatus(activeDisputId)

  const openCreateModal = () => setIsCreateDisputOpen(true)
  const closeCreateModal = () => setIsCreateDisputOpen(false)

  //handler для кнопки Взять в работу
  const openDisputDialog = (id: string) => {
    if (hasError) return

    setActiveDisputId(id)
    setIsDisputActionOpen(true)
    handleUpdateStatus({ id, status: DisputStatus.InProgress })
  }
  //handler для кнопки Перейти к спору
  const inProgressDisputDialog = (id: string) => {
    setActiveDisputId(id)
    setIsDisputActionOpen(true)
  }
  //Попап действий
  const acceptDispute = (amount: number, topupId: string) => {
    setIsDisputActionOpen(false)
    setConfirmedAmount(amount)
    setActiveTopupId(topupId)
    setIsConfirmAmountOpen(true)
  }
  const rejectDisput = () => {
    setIsDisputActionOpen(false)
    setIsRejectConfirmOpen(true)
  }

  // принять спор
  const confirmAmount = () => {
    handleUpdateStatus({
      id: activeDisputId,
      status: DisputStatus.Satisfied,
      disputAmountFromTrader: confirmedAmount,
      topupId: activeTopupId,
    })
    setIsConfirmAmountOpen(false)
    setIsAcceptResultOpen(true)
  }
  const closeAcceptResult = () => {
    setIsAcceptResultOpen(false)
    refetchDisputs?.()
  }
  // отклонить спор
  const closeRejectDialog = (description: string) => {
    handleUpdateStatus({ id: activeDisputId, status: DisputStatus.Rejected, description })
    setIsRejectConfirmOpen(false)
    setIsRejectResultOpen(true)
  }
  const closeRejectResult = () => {
    setIsRejectResultOpen(false)
    refetchDisputs?.()
  }

  return {
    activeDisputId,
    confirmedAmount,
    modalStates: {
      isCreateDisputOpen,
      isDisputActionOpen,
      isConfirmAmountOpen,
      isAcceptResultOpen,
      isRejectConfirmOpen,
      isRejectResultOpen,
    },
    modalSetters: {
      setIsCreateDisputOpen,
      setIsDisputActionOpen,
      setIsConfirmAmountOpen,
      setIsAcceptResultOpen,
      setIsRejectConfirmOpen,
      setIsRejectResultOpen,
    },
    handlers: {
      openCreateModal,
      acceptDispute,
      openDisputDialog,
      inProgressDisputDialog,
      confirmAmount,
      rejectDisput,
      closeCreateModal,
      closeRejectDialog,
      closeAcceptResult,
      closeRejectResult,
    },
  }
}
